import { useTranslation } from '../../../hooks/useTranslation';
import Button from '../../button/Button';
import './ProductSearchSectionHeader.less';

export type ProductSearchSectionHeaderProps = {
    title?: string;
    subtitle?: string;
    className?: string;
    visibleQuantity: number;
    totalQuantity?: number;
    onClickSubtitle?: (event: MouseEvent) => void;
};

const ProductSearchSectionHeader = ({
    title,
    subtitle,
    className = '',
    visibleQuantity,
    totalQuantity,
    onClickSubtitle
}: ProductSearchSectionHeaderProps) => {
    const { t } = useTranslation();
    return (
        <div className={`bri-ProductSearchSectionHeader ${className}`}>
            <div className={'bri-ProductSearchSectionHeader-titles-container'}>
                <span className="bri-TitleBoldFont">{title}</span>
                {subtitle && !onClickSubtitle && (
                    <span className="bri-DisplayFont bri-ProductSearchSectionHeader-subtitle">
                        {subtitle}
                    </span>
                )}
                {subtitle && onClickSubtitle && (
                    <div className="bri-ProductSearchSectionHeader-subtitle">
                        <Button
                            variant="link"
                            endIconId="arrow-right"
                            endIconSize="x-small"
                            onClick={onClickSubtitle}
                        >
                            {subtitle}
                        </Button>
                    </div>
                )}
            </div>
            <div className="bri-ProductSearchSectionHeader-quantity bri-Body2Font">
                {totalQuantity !== undefined &&
                    totalQuantity > visibleQuantity &&
                    t('RESULTS_OF_TOTAL', {
                        count: visibleQuantity,
                        total: totalQuantity
                    })}
            </div>
        </div>
    );
};

export default ProductSearchSectionHeader;
